<template>
    <tr class="licence__list_table_item">
        <td class="licence__list_table_item_createdat">
            {{licenceCreatedAtDate}}<br>
            <component-text :size="'tiny'">
                Time: {{licenceCreatedAtTime}}
            </component-text>
        </td>
        <td class="licence__list_table_item_coursename">{{licenceCourseName}}</td>
        <td class="licence__list_table_item_customer">{{licenceCustomerName}}</td>
        <td class="licence__list_table_item_total">{{licenceTotal}}</td>
        <td class="licence__list_table_item_left">{{licenceLeft}}</td>
        <td class="licence__list_table_item_used">{{licenceUsed}}</td>
        <td class="licence__list_table_item_startdate">{{licenceStartDate}}</td>
        <td class="licence__list_table_item_expirydate">{{licenceExpiryDate}}</td>
        <td class="licence__list_table_item_status">
            <component-status :status="licenceStatus"></component-status>
        </td>
        <td v-if="false" class="licence__list_table_item_actions">
            <div class="columns is-vcentered">
                <div class="column is-narrow">
                    <component-button-menu
                        v-if="user.isCourseLicenceManager() && dotsButtonMenuList.length"
                        :buttons="dotsButtonMenuList"
                    />
                </div>
            </div>
        </td>
        <td class="licence__list_table_item_actions">
            <template></template>
            <div class="columns">
                <div class="column"></div>
                    <div class="column is-narrow">
                        <component-button
                            :theme="'default'"
                            :name="'licence-list-table-item-actions-details'"
                            :to="{ name: 'ebs-licence-show', params: { offerId: licenceId, contractId: licenceContractId }, query: { courseName: licenceCourseName, customerName: licenceCustomerName } }"
                        >Details</component-button>
                    </div>
                <template v-if="dotsButtonMenuList.length">
                    <div class="column is-narrow">
                        <component-button-menu
                            :buttons="dotsButtonMenuList"
                            @emit-suspend="performEmit('emit-suspend', licenceId)"
                            @emit-restore="performEmit('emit-restore', licenceId)"
                            @emit-archive="performEmit('emit-archive', licenceId)"
                        ></component-button-menu>
                    </div>
                </template>
            </div>
        </td>
    </tr>
</template>

<script>
import ComponentButtonMenu from '@/components/default/shared/ComponentButtonMenu'
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import { toLocaleDateTime, toLocaleTime } from '@/functions'
import { User } from '@/User'
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentText from '@/components/default/shared/ComponentText'

export default {
  components: { ComponentText, ComponentButton, ComponentStatus, ComponentButtonMenu },
  name: 'licence-list-table-item',
  data () {
    return {
      user: new User()
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    licenceId () {
      return this.item.id
    },
    licenceCourseName () {
      return this.item.courseName
    },
    licenceCreatedAtDate () {
      return toLocaleDateTime(this.item.createdAt)
    },
    licenceCreatedAtTime () {
      return toLocaleTime(this.item.createdAt)
    },
    licenceCustomerName () {
      return this.item.customerName
    },
    licenceTotal () {
      return this.item.numberOfLicences
    },
    licenceContractId () {
      return this.item.contractId
    },
    licenceLeft () {
      return this.licenceTotal && this.licenceTotal.constructor === Number && this.licenceUsed.constructor === Number ? this.licenceTotal - this.licenceUsed : this.licenceTotal || '-'
    },
    licenceUsed () {
      return this.item.usedLicences
    },
    licenceStartDate () {
      return toLocaleDateTime(this.item.validFromDate) || '-'
    },
    licenceExpiryDate () {
      return toLocaleDateTime(this.item.validToDate) || '-'
    },
    licenceStatus () {
      const frontStatus = this.item.frontStatus
      const defaultStatus = this.item.status
      return frontStatus && frontStatus !== 'unknown' ? frontStatus : defaultStatus
    },
    //
    dotsButtonMenuList () {
      let menuArr = []

      if (this.licenceStatus === 'active') {
        menuArr.push({
          key: 'suspend',
          name: 'Suspend'
        })
      }
      if (this.licenceStatus === 'suspended') {
        menuArr.push({
          key: 'restore',
          name: 'Restore'
        })
        menuArr.push({
          key: 'archive',
          name: 'Archive'
        })
      }

      return menuArr
    }
  },
  methods: {
    performEmit (message, value) {
      this.$emit('emit', { message: message, value: value })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/licences/licencelisttableitem";
</style>
